import { httpService } from './http.service.js'
import store from '../store/index'

export const checksService = {
  getChecksToFill,
  addOrUpdateCheck,
  getEmptyCheck,
  getCheckImg,
  finishScan,
  deleteCheck,
  submitChecksGroup,
  getChecksListData,
  getChecksRoutes,
}

function getSessionToken() {
  return store.state.api.sessionToken
}

function getWorkerGuid() {
  return store.state.api.workerGUID
}

async function getChecksToFill(contactGuid) {
  const ChecksToFill = await httpService.get(`check/toFill`, {
    contactGuid,
  })

  return ChecksToFill
}

async function getCheckImg(chex_checkID, dir) {
  const response = await httpService.get(`check/image/?orientation=${dir}`, {
    chex_checkID,
  })

  let mimeType = 'image/jpeg'
  let imgUrl = `data:${mimeType};base64,${response.Image}`

  return imgUrl
}
async function addOrUpdateCheck(check) {
  check.SessionToken = getSessionToken()
  const response = await httpService.post(`check`, check)
  return response
}
async function finishScan(check) {
  const response = await httpService.put(`check/finishScan`, check)
  return response
}
async function deleteCheck(check) {
  const response = await httpService.delete(`check`, check)
  return response
}

async function submitChecksGroup(checksGroup) {
  checksGroup.SessionToken = getSessionToken()
  const response = await httpService.put(
    `check/submitChecksHeader `,
    checksGroup
  )
  return response
}

async function getChecksListData() {
  const response = await httpService.get(`check/listsData`, {
    WorkerGuid: getWorkerGuid(),
  })
  return response
}

// function to get a empty check object
export function getEmptyCheck(checksHeaderID, Amount, DepositDate) {
  return {
    CheckGuid: null,
    TransactionNumber: null,
    apiResponse: null,
    checksHeaderID: checksHeaderID,
    CheckStatus: 1,
    Amount: Amount,
    DepositDate: DepositDate,
    ApprovedByUserId: null,
    ApprovalDate: null,
    SentToDeposit: null,
    LastStatusChange: null,
    LastStatusChangeByUserID: null,
  }
}

function getChecksRoutes() {
  //get the checks from the store
  const checks = store?.getters?.checks
  if (checks?.length > 0) {
    const routes = ['ChecksFill', 'CheckCapture']
    if (checks.length > 1) {
      routes.unshift('ChecksPage')
    }
    return routes
  }
  return []
}

/*
{
    "CheckGuid": "a3180e35-33e0-4f02-9ebe-f33a9fad72ac",
    "TransactionNumber": 1032,
    //"apiResponse": "{\"TransactionNumber\":1032,\"Url\":\"https://test.chex.co.il/terminal/transaction/session/buildapp/1032/2e950fe0-a856-4fe0-b9aa-6e32470e30d2\"}",
    "checksHeaderID": 18,
    //"CheckStatus": null,
    "Amount": 348,
    //"CreateDate": null,
    "DepositDate": "2024-08-11T00:00:00",
    //"ApprovedByUserId": null,
    //"ApprovalDate": null,
    //"SentToDeposit": null,
    //"LastStatusChange": null,
    //"LastStatusChangeByUserID": null,
    "SessionToken": "00000000-0000-0000-0000-000000000000",
    "redirect": null,
    "chex_checkID": null,
    "scanUrl": "https://test.chex.co.il/terminal/transaction/session/buildapp/1032/2e950fe0-a856-4fe0-b9aa-6e32470e30d2"
}
*/
